import { useContext } from 'react';
import { SocketsContext } from '@/providers/SocketsProvider';

export function useSockets() {
  const context = useContext(SocketsContext);
  if (!context) {
    throw Error('useSockets must be used within the SocketsProvider');
  }
  return context;
}
